import { useCallback, useEffect, useState } from "react";
import { TradingWorkspace } from "@/components/TradingWorkspace";
import { ReleaseNotesPage } from "@/components/ReleaseNotesPage";
import ProxyMetricsPage from "@/pages/ProxyMetricsPage";
import { TokenGate } from "@/components/TokenGate";
import { AlgoDeployWorkspace } from "@/components/AlgoDeployWorkspace";
import { GlobalToasts } from "@/components/GlobalToasts";
import { WelcomeModal } from "@/components/WelcomeModal";
import { changelogPath, homePath, isChangelogPath, isWorkspacePath, workspacePath, isAlgoDeployPath } from "@/lib/siteUrls";

function isLocalhost(): boolean {
  if (typeof window === "undefined") return false;
  const h = window.location.hostname;
  return h === "localhost" || h === "127.0.0.1" || h === "0.0.0.0" || h.endsWith(".local");
}

function isProxyMetricsPath(path: string): boolean {
  return path === "/proxy-metrics" || path.startsWith("/proxy-metrics");
}

export default function App() {
  const [pathname, setPathname] = useState(() => {
    if (typeof window === "undefined") return "/";
    const currentPath = window.location.pathname;
    const home = homePath();
    const isHome = currentPath === home || currentPath === home.replace(/\/?$/, "") || (home === "/" && currentPath === "/");
    // Route unknown paths to workspace, but preserve the marketing home page.
    if (!isWorkspacePath(currentPath) && !isProxyMetricsPath(currentPath) && !isChangelogPath(currentPath) && !isAlgoDeployPath(currentPath) && !isHome) {
      const wp = workspacePath() + window.location.search;
      window.history.replaceState({}, "", wp);
      return workspacePath();
    }
    return currentPath;
  });

  useEffect(() => {
    const sync = () => setPathname(window.location.pathname);
    window.addEventListener("popstate", sync);
    
    return () => window.removeEventListener("popstate", sync);
  }, []);

  const openWorkspace = useCallback(() => {
    const next = workspacePath() + window.location.search;
    window.history.pushState({}, "", next);
    setPathname(workspacePath());
  }, []);

  if (isWorkspacePath(pathname)) {
    return (
      <>
        <GlobalToasts />
        <WelcomeModal />
        <TokenGate />
        <TradingWorkspace />
      </>
    );
  }

  if (isProxyMetricsPath(pathname) && isLocalhost()) {
    return (
      <>
        <GlobalToasts />
        <WelcomeModal />
        <ProxyMetricsPage />
      </>
    );
  }

  if (isChangelogPath(pathname)) {
    return (
      <>
        <GlobalToasts />
        <WelcomeModal />
        <ReleaseNotesPage
          homeHref={homePath()}
          workspaceHref={workspacePath()}
          changelogHref={changelogPath()}
          onOpenWorkspace={openWorkspace}
        />
      </>
    );
  }

  if (isAlgoDeployPath(pathname)) {
    // We will build AlgoDeployWorkspace next
    return (
      <>
        <GlobalToasts />
        <WelcomeModal />
        <AlgoDeployWorkspace />
      </>
    );
  }

  return (
      <>
        <GlobalToasts />
        <WelcomeModal />
        <TokenGate />
        <TradingWorkspace />
      </>
    );
}
